
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ParamBox extends Vue {
  @Prop({ default: 'UNTITLED' }) title!: string;
  @Prop({ default: 'list' }) icon!: string;
}
